<template>
  <div class="laborDialog">
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               :show-close="false"
               width="50%"
               top="10vh"
               :title="title">
      <div class="form-box">
        <el-form size="medium"
                 :model="form"
                 ref="Form"
                 label-position="left"
                 label-width="120px"
                 :rules="rules">

          <el-form-item :label="$t('labor.Name')"
                        prop="Name">
            <el-input v-model="form.Name"
                      size="small"
                      :placeholder="$t('labor.Name')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('labor.Trades')"
                        prop="Trades">
            <el-select style="width:100%"
                       v-model="form.Trades"
                       size="small"
                       @change="selectChange"
                       clearable
                       :collapse-tags="form.Trades.length> 4? true :false"
                       multiple>
              <el-option v-for="i in trades"
                         :key="i.Key"
                         :label="i.Value"
                         :value="i.Key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('labor.Retainage')"
                        prop="RetainageRate">
            <el-input v-model="form.RetainageRate"
                      size="small"
                      :placeholder="$t('labor.Retainage')">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>

          <el-form-item :label="$t('labor.Time Ranges:')"
                        prop="timeRanges">
            <el-popover placement="bottom"
                        v-model="dateShow"
                        @show="showPop"
                        trigger="click">
              <el-button slot="reference"
                         type="default"
                         size="small"
                         style="font-size:13px">{{timeRanges[0]}} - {{timeRanges[1]}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <div class="date-pop">
                <div class="date-type">
                  <el-radio-group v-model="dateType"
                                  @change="changDateType()"
                                  size="small">
                    <el-radio-button label="Presets"></el-radio-button>
                    <el-radio-button label="Range"></el-radio-button>
                    <el-radio-button label="Weeks"></el-radio-button>
                    <el-radio-button label="Months"></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="date-content">
                  <template v-if="dateType === 'Presets'">
                    <div class="Presets">
                      <div v-for="(item,index) in pickerOptions.shortcuts"
                           :key="index"
                           :style="{color:item.range=== rangeDate?color:''}"
                           @click="getRanges(item.range)">
                        <span>{{item.text}}</span>
                        <span>{{item.range}}</span>
                      </div>
                    </div>
                  </template>
                  <template v-if="dateType === 'Range'">
                    <div class="range">
                      <div class="range-input">
                        <el-date-picker type="date"
                                        size="small"
                                        value-format="MM/dd/yyyy"
                                        v-model="startDate"
                                        :clearable="false"
                                        placeholder="Start Date"
                                        @change="getStartDate"
                                        ref="start">
                        </el-date-picker>
                        -
                        <el-date-picker type="date"
                                        size="small"
                                        align="right"
                                        v-model="endDate"
                                        :clearable="false"
                                        value-format="MM/dd/yyyy"
                                        placeholder="End Date"
                                        @change="getEndDate"
                                        ref="end">
                        </el-date-picker>
                      </div>
                    </div>
                  </template>
                  <template v-if="dateType === 'Weeks'">
                    <div class="weeks">
                      <el-date-picker type="week"
                                      size="small"
                                      @change="getWeekDate"
                                      v-model="weekDate"
                                      :clearable="false"
                                      format="Week WW, yy"
                                      :picker-options="{firstDayOfWeek: 1}"
                                      ref="week">
                      </el-date-picker>
                    </div>
                  </template>
                  <template v-if="dateType === 'Months'">
                    <div class="month">
                      <el-date-picker type="month"
                                      size="small"
                                      :clearable="false"
                                      v-model="monthDate"
                                      @change="getmonthDate"
                                      ref="month">
                      </el-date-picker>
                    </div>
                  </template>
                </div>
              </div>
            </el-popover>
          </el-form-item>

          <template v-if="showMore">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item label="Sub Cont.">
                  <el-input v-model="form.SubContract"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Sub Cont. Address">
                  <el-input v-model="form.SubContLocation"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Sub Cont. PO#">
                  <el-input v-model="form.SubContPONumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Job #">
                  <el-input v-model="form.JobNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Application Number">
                  <el-input v-model="form.ApplicationNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Application Date">
                  <el-date-picker style="width:100%"
                                  v-model="form.ApplicationDate">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Pay Period Ending">
                  <el-date-picker style="width:100%"
                                  v-model="form.PayPeriodEnding">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="small"
                   @click="closeDialog('cancel')">{{$t('labor.Cancel')}}</el-button>
        <el-button size="small"
                   @click="PostProjectLaborGroups"
                   type="primary">{{$t('labor.Save')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetProductTrades,
  PostProjectLaborGroups
} from '@/api/config'
import { mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
moment.locale('zh-cn')
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    editForm: {
      type: Object,
      default: null
    }
  },
  components: {

  },
  data () {
    let validateRetainageRate = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('labor.Please Enter Retainage Rate')))
      } else {
        let reg = /(^[0-9][0-9]*(.[0-9]+)?)$/
        if (new RegExp(reg).test(value) === false) {
          callback(new Error('Please Enter  a number'))
        } else {
          if (value > 100 || value < 0) {
            callback(new Error(this.$t('labor.Please Enter Retainage Rate from 0 to 100')))
          } else {
            callback()
          }
        }
      }
    }
    return {
      dateType: 'Presets',
      lastEnterDateType: 'Presets',
      color: '#4193f6',
      rangeDate: '',
      monthDate: '',
      weekDate: '',
      startDate: '',
      endDate: '',
      dateShow: false,
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last Week',
            range: (moment().week(moment().week() - 1).startOf('week').format('MM/DD/yyyy')) + ' - ' + moment().week(moment().week() - 1).endOf('week').format('MM/DD/yyyy'),
            startDate: moment().week(moment().week() - 1).startOf('week').format('MM/DD/yyyy'),
            endDate: moment().week(moment().week() - 1).endOf('week').format('MM/DD/yyyy')
          },
          {
            text: 'Last Month',
            range: (moment().month(moment().month() - 1).startOf('month').format('MM/DD/yyyy')) + ' - ' + moment().month(moment().month() - 1).endOf('month').format('MM/DD/yyyy'),
            startDate: moment().month(moment().month() - 1).startOf('month').format('MM/DD/yyyy'),
            endDate: moment().month(moment().month() - 1).endOf('month').format('MM/DD/yyyy')
          },
          {
            text: 'Last 7 Days',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('MM/DD/yyyy')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('MM/DD/yyyy'),
            endDate: moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          },
          {
            text: 'Last 30 Days',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 30).format('MM/DD/yyyy ')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 30).format('MM/DD/yyyy'),
            endDate: moment(new Date() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          },
          {
            text: 'Last 90 Days ',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 90).format('MM/DD/yyyy ')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 90).format('MM/DD/yyyy'),
            endDate: moment(new Date() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          }
        ]
      },
      timeRanges: [],
      date: '',
      title: this.$t('labor.Add Labor Group'),
      showMore: false,
      trades: [],
      rules: {
        Name: [
          { required: true, message: this.$t('labor.Please Enter A Name'), trigger: 'blur' }
        ],
        RetainageRate: [
          { required: true, trigger: 'blur', validator: validateRetainageRate }
        ]
      },
      form: {
        CorpId: 0,
        JobsiteId: '',
        Name: '',
        SubContract: '',
        SubContLocation: '',
        SubContPONumber: '',
        JobNumber: '',
        ApplicationNumber: '',
        ApplicationDate: '',
        PayPeriodEnding: '',
        RetainageRate: null,
        IsDeleted: false,
        Trades: ['OPTION_ALL'],
        StartDate: '',
        EndDate: ''
      }
    }
  },
  created () {
  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.GetProductTrades()
        this.form = this.editForm
        this.lastEnterDateType = 'Presets'
        this.timeRanges = []
        this.rangeDate = ''
        this.monthDate = ''
        this.weekDate = ''
        this.startDate = ''
        this.endDate = ''
        if (this.form.LaborGroupId) {
          this.title = this.$t('labor.Edit Labor Report')
          this.timeRanges.push(this.form.StartDate)
          this.timeRanges.push(this.form.EndDate)
        } else {
          this.rangeDate = this.pickerOptions.shortcuts[0].range
          this.timeRanges = this.pickerOptions.shortcuts[0].range.split('-')
        }
      }
    },
    dateShow (to, from) {
      if (!to) {
        if (this.timeRanges.length < 1) {
          this.timeRanges = []
          if (this.form.LaborGroupId) {
            this.timeRanges.push(this.form.StartDate)
            this.timeRanges.push(this.form.EndDate)
          } else {
            this.timeRanges = this.pickerOptions.shortcuts[0].range.split('-')
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'corpId'])
  },
  mounted () {
    this.GetProductTrades()
  },
  methods: {
    showPop () {
      this.dateType = this.lastEnterDateType
      this.$nextTick(() => {
        if (this.dateType === 'Weeks') {
          this.$refs.week.$refs.reference.focus()
        }
        if (this.dateType === 'Months') {
          this.$refs.month.$refs.reference.$refs.input.focus()
        }
        if (this.dateType === 'Range') {
          this.$refs.start.$refs.reference.$refs.input.focus()
        }
      })
    },
    getRanges (value) {
      this.rangeDate = value
      this.timeRanges = this.rangeDate.split('-')
      this.lastEnterDateType = 'Presets'
      this.dateShow = false
    },
    getEndDate () {
      this.timeRanges = []
      this.timeRanges.push(this.startDate)
      this.timeRanges.push(this.endDate)
      this.dateShow = false
      this.lastEnterDateType = 'Range'
    },
    getStartDate () {
      this.$refs.end.$refs.reference.$refs.input.focus()
    },
    getmonthDate () {
      var date1 = moment(this.monthDate).startOf('month').format('MM/DD/yyyy')
      var date2 = moment(this.monthDate).endOf('month').format('MM/DD/yyyy')
      this.timeRanges = []
      this.timeRanges.push(date1)
      this.timeRanges.push(date2)
      this.lastEnterDateType = 'Months'
      this.dateShow = false
    },
    getWeekDate () {
      var date = moment(this.weekDate)
      var dow = date.day()
      var monday = date.subtract(dow - 1, 'days').format('MM/DD/yyyy')// 本周一
      var sunday = moment(monday).subtract(-6, 'days').format('MM/DD/yyyy')// 本周日
      this.timeRanges = []
      this.timeRanges.push(monday)
      this.timeRanges.push(sunday)
      this.lastEnterDateType = 'Weeks'
      this.dateShow = false
    },
    changDateType () {
      if (this.dateType === 'Weeks') {
        this.$refs.week.$refs.reference.$refs.input.focus()
      }
      if (this.dateType === 'Months') {
        this.$refs.month.$refs.reference.$refs.input.focus()
      }
      if (this.dateType === 'Range') {
        this.$refs.start.$refs.reference.$refs.input.focus()
      }
    },
    selectChange () {
      let hasAll = false
      for (let j of this.form.Trades) {
        if (j === 'OPTION_ALL') {
          hasAll = true
        }
      }
      if (this.form.Trades.length > 1 && this.form.Trades[0] === 'OPTION_ALL') {
        for (let i in this.form.Trades) {
          if (this.form.Trades[i] === 'OPTION_ALL') {
            this.form.Trades.splice(i, 1)
          }
        }
      } else if (this.form.Trades.length < 1) {
        this.form.Trades = ['OPTION_ALL']
      } else if (this.form.Trades.length > 1 && this.form.Trades[0] !== 'OPTION_ALL' && hasAll) {
        this.form.Trades = ['OPTION_ALL']
      }
    },
    closeDialog (type) {
      this.form = {
        timeRanges: '',
        CorpId: 0,
        JobsiteId: '',
        Name: '',
        SubContract: '',
        SubContLocation: '',
        SubContPONumber: '',
        JobNumber: '',
        ApplicationNumber: '',
        ApplicationDate: null,
        PayPeriodEnding: null,
        RetainageRate: null,
        IsDeleted: false,
        Trades: ['OPTION_ALL']
      }

      this.$refs['Form'].resetFields()
      this.$refs['Form'].clearValidate()
      this.$emit('closeDialog', type)
    },
    PostProjectLaborGroups () {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          if (this.form.Trades.length === 1 && this.form.Trades[0] === '') {
            this.form.Trades = []
          }
          this.btnLoading = true
          let pass = _.cloneDeep(this.form)
          let rate = this.$config.divide(pass.RetainageRate, 100).toFixed(4)
          pass.JobsiteId = this.jobsiteID
          pass.CorpId = this.corpId
          pass.RetainageRate = rate
          pass.StartDate = this.timeRanges[0]
          pass.EndDate = this.timeRanges[1]
          pass.StartDate = this.$config.UTCTime(pass.StartDate, false, true)
          pass.EndDate = this.$config.UTCTime(pass.EndDate, false, true)
          let array = []
          array.push(pass)
          PostProjectLaborGroups(array).then(res => {
            this.btnLoading = false
            this.closeDialog('save')
          })
        }
      })
    },
    GetProductTrades () {
      let pass = {
        JobsiteId: this.jobsiteID
      }
      GetProductTrades(pass).then(res => {
        this.trades = res
      })
    },
    switchMore () {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style lang="scss" scoped>
.form-box {
  max-width: 500px;
  margin: 0 auto;
  overflow: hidden;
}

.laborDialog {
  .el-divider--horizontal {
    margin: 0;
  }
}
.date-pop {
  .date-type {
    margin: 0 auto 20px;
    text-align: center;
  }
  .date-content {
    .Presets {
      display: flex;
      flex-direction: column;
      width: 324px;
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 15px;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
    .weeks {
      width: 324px;
      height: 386px;
      .el-input {
        width: 100%;
      }
    }
    .month {
      width: 324px;
      height: 300px;
      .el-input {
        width: 100%;
      }
    }
    .range {
      width: 324px;
      height: 386px;
      .range-input {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .el-input {
          width: 45%;
        }
      }
    }
  }
  .date-btn {
    margin-top: 10px;
  }
}
</style>
